module.exports = __webpack_public_path__ + "static/media/flag.26adbc32.svg";